module.exports = __webpack_public_path__ + "ml.svg?ff693a505f163781601968cd7ff13fca";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ml.svg
// module id = 1071
// module chunks = 27